<template>
  <el-container>
    <!-- 主体内容 -->
    <el-header
      style="display: flex; align-items: center; justify-content: space-between"
    >
      <el-breadcrumb separator="/">
        <!-- <el-breadcrumb-item>上报负面舆情</el-breadcrumb-item> -->
        <el-breadcrumb-item>手动工单录入</el-breadcrumb-item>
      </el-breadcrumb>
      <el-button-group>
        <el-button
          type="info"
          icon="el-icon-save"
          @click.native="formSubmit(-2)"
          >创建</el-button
        >
        <el-button type="info" icon="el-icon-back" @click.native="formReturn()"
          >返 回</el-button
        ></el-button-group
      >
    </el-header>
    <el-main>
      <el-tabs type="card" :tab-position="tabPosition">
        <el-tab-pane>
          <!-- <span slot="label"><i class="el-icon-date"></i> 负面舆情信息</span> -->
          <span slot="label"><i class="el-icon-date"></i> 工单信息</span>
          <el-form
            ref="refForm"
            :model="data.pst"
            status-icon
            label-width="100px"
            :rules="rules"
          >
            <el-form-item label="工单类型" prop="pstType">
              <el-select v-model="data.pst.pstType" placeholder="请选择">
                <el-option
                  v-for="pstType in pstApi.pstTypes.filter((item) =>
                    data.user.hasRoles.isAdmin || data.user.hasRoles.isSuper
                      ? item.value >= 0
                      : item.value == 1
                  )"
                  :key="pstType.value"
                  :label="pstType.title"
                  :value="pstType.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="发贴标题" prop="title">
              <el-input v-model="data.pst.title" />
            </el-form-item>
            <el-form-item label="发贴地址" prop="pstUrl">
              <el-input v-model="data.pst.pstUrl" />
            </el-form-item>
            <el-form-item label="发贴人" prop="name">
              <el-input v-model="data.pst.name" />
            </el-form-item>
            <el-form-item label="发贴时间" prop="postingTime">
              <el-input v-model="data.pst.postingTime" />
            </el-form-item>
            <el-form-item label="来源" prop="pstSource">
              <el-input v-model="data.pst.pstSource" />
            </el-form-item>
            <el-form-item label="贴子内容" prop="pstContent">
              <el-input
                type="textarea"
                :rows="10"
                v-model="data.pst.pstContent"
              />
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </el-main>
  </el-container>
</template>
  
<script>
export default {
  created() {
    this.pstApi.setWindowTitle("创建工单信息");
    this.data.user = this.pstApi.getUserData();
    //console.log(this.data.user)
  },
  data() {
    var checkPstType = (rules, value, callback) => {
      if (value != 0 && value != 1) {
        callback(new Error("类型错误!"));
      } else if (
        value == 0 &&
        this.data.user.isAdmin == false &&
        data.user.isSuper == false
      ) {
        callback(new Error("类型权限不足!"));
      } else {
        callback();
      }
    };
    var checkUrl = (rules, value, callback) => {
      if (!this.Common.isURL(value)) {
        callback(new Error("网址格式错误!"));
      } else {
        callback();
      }
    };
    var checkPostTime = (rules, value, callback) => {
      if (!this.Common.isDate(value)) {
        callback(new Error("日期格式错误!"));
      } else if (new Date(value) < new Date("2024-1-1")) {
        callback(new Error("日期不能小于（2024-1-1）"));
      } else {
        callback();
      }
    };
    return {
      tabPosition: "top",
      //数据项
      data: {
        statusName: "",
        pstTypeName: "",
        pst: {
          pstType: 1,
          title: "",
          pstUrl: "",
          name: "",
          postingTime: "",
          pstSource: "",
          pstContent: "",
        },
        nodes: [],
        user: "",
      },
      rules: {
        pstType: [{ required: true, trigger: "blur", validator: checkPstType }],
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        pstUrl: [{ required: true, trigger: "blur", validator: checkUrl }],
        postingTime: [
          { required: true, trigger: "blur", validator: checkPostTime },
        ],
        name: [{ required: true, message: "请输入发贴人", trigger: "blur" }],
        pstSource: [{ required: true, message: "请输入来源", trigger: "blur" }],
        pstContent: [
          { required: true, message: "请输入留言内容", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    formReturn() {
      this.$router.back();
    },
    formSubmit(category) {
      this.$refs["refForm"].validate((valid) => {
        if (!valid) {
          console.log("error submit!!");
          this.$toast("数据校验错误");
          return false;
        } else {
          //return false;
          let pst = this.data.pst;
          this.pstApi
            .createNegative(
              pst.title,
              pst.pstUrl,
              pst.name,
              pst.postingTime,
              pst.pstSource,
              pst.pstContent,
              category,
              pst.pstType
            )
            .then((res) => {
              //进入编辑页面
              //console.log(res)
              let pstId = res.data.data;
              //console.log(pstId)
              if (pstId) {
                this.$router.push({
                  name: "EditNegative",
                  params: { id: pstId },
                });
              }
            })
            .catch((err) => {
              var message = "创建失败";
              if (err.response.data) {
                //console.log(err.response);
                message = err.response.data.Message;
              }
              this.$toast(message);
            });
        }
      });
    },
  },
};
</script>
  
<style lang="less" scoped>
.el-header {
  background-color: #b3c0d1;
  color: #333;
  line-height: 40px;
}
//工具栏样式
.cust_seach {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  width: 100%;
  padding: auto 5px;
  .btnLeft {
    flex: 1;
    margin: 0;
    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
  }
  .btnTitle {
    flex: 2;
    margin: 0;
    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
    }
  }
  .btnStatus {
    flex: 1;
    margin: 0;
    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-right-radius: 0px;
      border-bottom-right-radius: 0px;
    }
  }
  .el-button-group > .el-button:first-child:last-child {
    border-radius: 0px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
}
.el-select {
  float: left;
}
.cust_pagin {
  display: flex;
  position: sticky;
  bottom: 0;
  z-index: 999;
}
/deep/.el-breadcrumb__separator {
  color: rgb(87, 86, 86);
}
/deep/.el-textarea.is-disabled .el-textarea__inner {
  background-color: #fff;
  border-color: #e4e7ed;
  color: #031944;
  cursor: auto;
}
/deep/.el-input.is-disabled .el-input__inner {
  background-color: #fff;
  border-color: #e4e7ed;
  color: #031944;
  cursor: auto;
}
</style>